import { IState } from '../../store';

export function selectDescription(state: IState) {
  return state.offerData.offer.description;
}
